import styled from "styled-components";
import { rel8LightPurple, rel8Pink, rel8Purple, rel8White } from "../../globals";
import { mobile, tablet } from "../../responsive";

export const MembersContainer = styled.div`
    margin-top: 67px;
    margin-left: 220px;
    padding: 50px 30px;
    background-color: ${rel8Pink};
    min-height: 100vh;
    ${
        mobile({
            marginTop: "0px",
            marginLeft: "0px",
        })
    }
    ${
        tablet({
            marginTop: "0px",
            marginLeft: "0px",
        })
    }
`
export const MembersPersonTab = styled.div`
    display: flex;
    justify-content: ${props=>props.typex==="dues" ? "":"space-evenly"};
    ${
        mobile({
            flexDirection: "column",
        })
    }
`
export const MembersPersons = styled.span`
    color: ${rel8Purple};
    font-weight: 600;
    cursor: pointer;
    margin-right: ${props=>props.typex==="dues" ? "20px":""};
    position: relative;
    &::after{
        content: "";
        height: 2px;
        background-color: ${rel8Purple};
        width: 100%;
        display: ${props=>props.filled==="show" ? "block": "none"};
        position: absolute;
        bottom: 0;
        left: 0;
    }
    ${
        mobile({
            marginBottom: "10px",
        })
    }
`
export const MembersSearch = styled.div`
    margin: 40px 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    ${
        mobile({
            flexDirection: "column",
        })
    }
`
export const MembersSearchCompCon = styled.div`
        width: 70%;
        display: flex;
        ${
        mobile({
            width: "100%",
        })
    }
`
export const MembersSearchInput = styled.input`
    width: 80%;
    outline: none;
    padding: 20px;
    border: none;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    background-color: ${rel8Pink};
    color: ${rel8Purple};

    &::placeholder{
        color: ${rel8Purple};
    }
    ${
        mobile({
            width: "80%",
        })
    }
`
export const MembersSearchBtn = styled.button`
    color: black;
    outline: none;
    padding: 20px;
    border: none;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    cursor: pointer;
    background-color: ${rel8Pink};
    ${
        mobile({
            width: "20%",
        })
    }
`
export const AddNewBtn = styled.button`
    border: none;
    color: ${rel8White};
    background-color: ${rel8Purple};
    padding: 10px 20px;
    border-radius: 10px;
    cursor: pointer;
    ${
        mobile({
            margin: "20px 0px",
        })
    }
`
export const MembersPersonList = styled.div`
    width: 100%;
    /* background-color: ${rel8White}; */
    border-radius: 10px;
    padding: 20px 0px;
`
export const MembersPaginationCon = styled.div`
    display: flex;
    overflow-x: auto;
    align-items: center;
    margin: 20px 0px;
    padding: 5px 10px;
`
export const MembersPaginationItem = styled.span`
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    background-color: ${rel8White};
    color: ${rel8Purple};
    margin-right: 20px;
    cursor: pointer;
`

export const MemberHeadingContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  width: 100%;
`;

export const SubCon = styled.div`
  background-color: ${rel8White};
  width: 350px;
  height: 500px;
  border-radius: 10px;
  padding: 20px;
  overflow-y: auto;

  ${mobile({
    width: "250px",
  })}
`;

export const SubConHeader = styled.p`
  font-weight: 700;
  text-align: center;
`;

export const Form = styled.form`
  margin: 20px 0px;
  display: flex;
  flex-direction: column;
`;

export const FormLabel = styled.label`
  display: flex;
  flex-direction: column;
  gap: 5px;
  font-size: 14px;
  font-weight: 500;
  color: #444;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
`;

export const Button = styled.button`
  padding: 10px 15px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

export const SubmitButton = styled(Button)`
  background-color: ${rel8Purple};
  color: white;
  
  &:hover:not(:disabled) {
    background-color: ${rel8LightPurple};
  }
`;

export const CancelButton = styled(Button)`
  background-color: #f8f9fa;
  color: #343a40;
  
  &:hover:not(:disabled) {
    background-color: #e2e6ea;
  }
`;